import { useEffect } from "react";

// Renders Instagram blockquote that auto-converts to embed via Instagram embed.js script
const InstagramEmbed = ({ url }) => {
  useEffect(() => {
    // Inject script once
    const id = "instagram-embed-script";
    if (!document.getElementById(id)) {
      const s = document.createElement("script");
      s.id = id;
      s.src = "https://www.instagram.com/embed.js";
      s.async = true;
      document.body.appendChild(s);
    } else if (window.instgrm) {
      window.instgrm.Embeds.process();
    }
    // Re-process embeds when URL changes
    const t = setTimeout(() => {
      if (window.instgrm) window.instgrm.Embeds.process();
    }, 500);
    return () => clearTimeout(t);
  }, [url]);

  if (!url) return null;
  return (
    <blockquote
      className="instagram-media"
      data-instgrm-permalink={url}
      data-instgrm-version="14"
      style={{ background: "#FFF", border: 0, margin: 0, padding: 0, maxWidth: "100%", width: "100%" }}
    />
  );
};

export default InstagramEmbed;
